export default "__VITE_ASSET__A59dJ3jj__"